import { ComponentType, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiActivity, FiBookOpen, FiChevronLeft, FiFlag, FiGrid, FiHome, FiLayers, FiMenu, FiMessageCircle, FiPlayCircle, FiUsers, FiVideo, FiX } from 'react-icons/fi';
import './AdminPage.css';
import AnalyticsDashboard from './components/AnalyticsDashboard';
import PostManage from './components/PostManage';
import CommentManage from './components/CommentManage';
import UserManage from './components/UserManage';
import CategoryManage from './components/CategoryManage';
import AppContentManage from './components/AppContentManage';
import AppTopVideoManage from './components/AppTopVideoManage';
import AppShortsManage from './components/AppShortsManage';
import AppStoryManage from './components/AppStoryManage';
import AppNoticeManage from './components/AppNoticeManage';
import AppCommentManage from './components/AppCommentManage';
import AppShowcaseManage from './components/AppShowcaseManage';
import ReportManage from './components/ReportManage';

type IconProps = { 'aria-hidden'?: boolean | 'true' | 'false'; className?: string };
const icon = (value: unknown) => value as ComponentType<IconProps>;
const ActivityIcon = icon(FiActivity), BookIcon = icon(FiBookOpen), BackIcon = icon(FiChevronLeft);
const GridIcon = icon(FiGrid), HomeIcon = icon(FiHome), LayersIcon = icon(FiLayers), MenuIcon = icon(FiMenu);
const MessageIcon = icon(FiMessageCircle), PlayIcon = icon(FiPlayCircle), UsersIcon = icon(FiUsers), VideoIcon = icon(FiVideo), CloseIcon = icon(FiX);
const FlagIcon = icon(FiFlag);

const MENU_ITEMS = [
    { id: 'analytics', label: '접속 통계', group: '인사이트', icon: <ActivityIcon />, component: <AnalyticsDashboard /> },
    { id: 'posts', label: '게시글 관리', group: '커뮤니티', icon: <BookIcon />, component: <PostManage /> },
    { id: 'comments', label: '댓글 관리', group: '커뮤니티', icon: <MessageIcon />, component: <CommentManage /> },
    { id: 'users', label: '회원 관리', group: '커뮤니티', icon: <UsersIcon />, component: <UserManage /> },
    { id: 'reports', label: '신고 관리', group: '커뮤니티', icon: <FlagIcon />, component: <ReportManage /> },
    { id: 'categories', label: '카테고리 관리', group: '커뮤니티', icon: <LayersIcon />, component: <CategoryManage /> },
    { id: 'appContents', label: '앱 게시물', group: '앱 콘텐츠', icon: <GridIcon />, component: <AppContentManage /> },
    { id: 'topVideo', label: '앱 상단 영상', group: '앱 콘텐츠', icon: <VideoIcon />, component: <AppTopVideoManage /> },
    { id: 'shorts', label: '쇼츠', group: '앱 콘텐츠', icon: <PlayIcon />, component: <AppShortsManage /> },
    { id: 'stories', label: '이야기', group: '앱 콘텐츠', icon: <BookIcon />, component: <AppStoryManage /> },
    { id: 'notice', label: '공지사항', group: '운영', icon: <MessageIcon />, component: <AppNoticeManage /> },
    { id: 'appComments', label: '앱 댓글', group: '운영', icon: <MessageIcon />, component: <AppCommentManage /> },
    { id: 'showcase', label: '자랑게시판', group: '운영', icon: <GridIcon />, component: <AppShowcaseManage /> }
];

const AdminPage = () => {
    const navigate = useNavigate();
    const [selectedMenu, setSelectedMenu] = useState('analytics');
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const selected = MENU_ITEMS.find(item => item.id === selectedMenu) || MENU_ITEMS[0];
    const groups = Array.from(new Set(MENU_ITEMS.map(item => item.group)));

    if(localStorage.getItem('role') !== 'ADMIN' || !localStorage.getItem('token')) {
        return <main className="admin-access"><h1>관리자 로그인이 필요합니다.</h1><p>관리자 계정으로 로그인한 뒤 다시 접속해 주세요.</p><a href="#/login">로그인하기 ↗</a></main>;
    }

    return <div className="admin-page">
        <header className="admin-mobile-header">
            <button className="menu-toggle-button" onClick={() => setSidebarOpen(true)} aria-label="관리자 메뉴 열기"><MenuIcon /></button>
            <div><span>TRUTHPICK</span><strong>{selected.label}</strong></div>
            <button className="back-home-button-mobile" onClick={() => navigate('/')} aria-label="사이트로 이동"><HomeIcon /></button>
        </header>
        {sidebarOpen && <button className="sidebar-overlay" onClick={() => setSidebarOpen(false)} aria-label="메뉴 닫기" />}
        <aside className={`admin-sidebar ${sidebarOpen ? 'open' : ''}`}>
            <div className="admin-sidebar-header">
                <button className="admin-brand" onClick={() => navigate('/')}><span>T</span><div><strong>TruthPick</strong><small>관리자 콘솔</small></div></button>
                <button className="sidebar-close-button" onClick={() => setSidebarOpen(false)} aria-label="관리자 메뉴 닫기"><CloseIcon /></button>
            </div>
            <nav className="admin-sidebar-nav">{groups.map(group => <div className="admin-menu-group" key={group}><span>{group}</span>{MENU_ITEMS.filter(item => item.group === group).map(item => <button key={item.id} className={`sidebar-menu-item ${selectedMenu === item.id ? 'active' : ''}`} onClick={() => { setSelectedMenu(item.id); setSidebarOpen(false); }}>{item.icon}<span>{item.label}</span>{selectedMenu === item.id && <i />}</button>)}</div>)}</nav>
            <button className="sidebar-home-button" onClick={() => navigate('/')}><BackIcon /> 사이트로 돌아가기</button>
        </aside>
        <main className="admin-main"><div className="admin-content">{selected.component}</div></main>
    </div>;
};

export default AdminPage;
